import { Directive } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, ValidationErrors, Validator } from '@angular/forms';

import { environment } from 'src/environments/environment';

@Directive({
  selector: '[appMinDate]',
  providers: [{ provide: NG_VALIDATORS, useExisting: MinDateDirective, multi: true }],
})
export class MinDateDirective implements Validator {
  minDate = new Date(environment.yearLimit, 0, 1).getTime();
  validate(control: AbstractControl): ValidationErrors | null {
    if (!control.hasError('required') && control.value === null) {
      return null;
    }
    if (control.touched && control.value === null) {
      return { minDate: true };
    }

    if (control.value) {
      const date = new Date(control.value).getTime();
      if (date > this.minDate) {
        return null;
      }

      return { minDate: true };
    }

    return null;
  }
}
